let scrollToElementLinks = document.querySelectorAll('.scroll-to-element-link');
let closePreview =  document.querySelector('.close-canton-map-preview');

for (let i = 0, len = scrollToElementLinks.length; i < len; i++) {
    scrollToElementLinks[i].addEventListener('click', function(event) {
        let element = document.querySelector(this.dataset.link);
        if(!element) {
            return;
        }
        if (window.innerWidth < 768 && document.body.classList.contains('preview-opened') && closePreview) {
            closePreview.click();
        }
        event.preventDefault();
        document.querySelector(this.dataset.link).parentNode.parentNode.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest'});
    });
}